<template>
  <van-dialog
    v-model="show"
    class="dialog"
    show-cancel-button
    @close="confirm"
    @confirm="confirm"
  >
    <van-form style="position: relative; margin-top: 1rem; display: flex">
      <van-field v-model="formData.name" name="name" label="供应商名称" />
      <van-button type="primary" @click="search">查询</van-button>
    </van-form>
    <van-list
    class="scrollList"
      :finished="finished"
      :loading-text="'加载中...'"
      :finished-text="'已显示全部'"
      @load="onLoad"
      v-model="loading"
      :error="error"
      :error-click="search"
    >
      <van-cell
        ref="cell"
        v-for="item in categoryList"
        :key="item.name"
        :title="item.name"
        @click="showActive(item)"
      />
    </van-list>
    <!-- <van-cell style="position: absolute;bottom:0;">
      <van-button round block type="primary" @click="confirm">
        提交
      </van-button>
    </van-cell> -->
  </van-dialog>
</template>
<script>
import { AVAILABLE } from "../utils/constants";
import { reqSupplier } from "../service/api/product";
// 导入样式
export default {
  name: "supplierSelect",
  components: {},
  props: {
    visible: false,
  },
  data() {
    return {
      error:false,
      loading: false,
      finished: false,
      show: false,
      data: [],
      formData: { name: "", available: true, pageIndex: 1, pageSize: 20 },
      columns: [
        {
          label: "编号",
          prop: "id",
        },
        {
          label: "名称",
          prop: "name",
        },
        {
          label: "状态",
          prop: "available",
        },
      ],
      statusList: AVAILABLE,
      categoryList: [],
      currentRow: {},
    };
  },
  watch: {
    visible(newVal, oldVal) {
      this.show = newVal;
    },
  },
  mounted() {
    
    this.getProductList();
  },
  methods: {
    onLoad() {
      
      this.formData.pageIndex++;
      this.getProductList(true);
    },
    search() {
      this.formData.pageIndex = 1;
      this.getProductList();
    },
    showActive(item) {
      this.currentRow = item;

      const exitIndex = this.categoryList.findIndex((i) => i.id === item.id);
      this.$refs.cell.forEach((el, index) => {
        el.classList.remove("active");
        if (index == exitIndex) {
          el.classList.add("active");
        }
      });
    },
    confirm() {
      this.$emit("confirm", this.currentRow);
      this.show = false;
      this.currentRow = {};
    },
    getProductList(flag) {
      this.finished = false;
      this.loading = true;
      reqSupplier(this.formData)
        .then((res) => {
          if (flag) {
            
            this.data=this.data.concat(res.data.datas);
            
          } else {
            this.data = res.data.datas;
          }
          this.categoryList = this.data;
          if (this.formData.pageIndex >= res.data.totalPage) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.error=true
          this.finished = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.active {
  background: #1989fa;
}
.dialog {
  height: 80%;
}

::v-deep .van-dialog__content {
  height: 100%;

  // .van-form {
  //   height: 100%;
  // }
}

.scrollList {
  height: calc(100% - 115px) !important;

  overflow: auto;
}
::v-deep .van-dialog__footer {
  position: sticky;
  bottom: 0;
}
::v-deep .van-cell {
  padding: 2px 10px !important;
}
</style>
